import type { PropsWithChildren } from 'react';
import { useCallback, useState } from 'react';

import ChevronIcon from 'public/new_chevron.svg';

import { Typography } from '../Typography';

import { ChevronSVG, CollapsedSectionContainer, CollapsibleSectionContainer } from './styles';

interface CollapsibleSectionProps
  extends PropsWithChildren<{
    collapsedTitle: string;
  }> {}

export const CollapsibleSection = ({ collapsedTitle, children }: CollapsibleSectionProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleIsCollapsed = useCallback(() => {
    setIsCollapsed(tmpIsCollapsed => !tmpIsCollapsed);
  }, []);

  return (
    <CollapsibleSectionContainer onClick={toggleIsCollapsed}>
      {isCollapsed && collapsedTitle ? (
        <CollapsedSectionContainer>
          <Typography variant={'body'}>{collapsedTitle}</Typography>
          <ChevronSVG src={ChevronIcon} />
        </CollapsedSectionContainer>
      ) : (
        children
      )}
    </CollapsibleSectionContainer>
  );
};
